export type PkilErrorCode =
  | "MALFORMED" // truncated data, bad field value, trailing bytes
  | "BAD_MAGIC"
  | "BAD_VERSION"
  | "CHAIN" // previous-hash mismatch
  | "SEQUENCE" // chunk sequence gap / missing header / unexpected header
  | "FRAME_ORDER" // record frames out of order or outside the chunk range
  | "ARGUMENT" // invalid writer argument
  | "ZSTD"
  | "TOO_LARGE";

export class PkilError extends Error {
  readonly code: PkilErrorCode;
  constructor(code: PkilErrorCode, message: string) {
    super(`PKIL ${code}: ${message}`);
    this.name = "PkilError";
    this.code = code;
  }
}
